import { gql } from "@apollo/client";

// Resolves a single node's client (owner) — e.g. a company root picked in the
// root-only InfrastructureBrowser, which only reports the node id. Never look
// the owner up in the full root list instead: unpaginated with owner fields,
// that list fails in the subgraph for users who see thousands of companies.
export const InstalledBaseNodeOwner = gql`
    query InstalledBaseNodeOwner($id: ID!) {
        installedBaseNode(id: $id) {
            id
            owner {
                id
            }
        }
    }
`;
